<template>
  <div class="no-scrollbar -mx-4 overflow-auto">
    <div
      class="flex w-fit items-center space-x-2 p-4"
      :class="isCalendarFilterApplied && 'mb-18'"
    >
      <FilterTooltip
        :is-visible="isCalendarFilterApplied"
        @onClose="showTooltip = false"
      >
        <FreeButton
          class="mini-filter-button"
          :class="{
            active: isFilterApplied(filtersConfig.FILTER_STAGES.MAIN),
          }"
          type="button"
          @click="emit('onOpenFilters')"
        >
          <span>
            <!-- eslint-disable -->
            <svg
              width="20"
              height="20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.877 8.846c1.405 0 2.544-1.103 2.544-2.464 0-1.362-1.139-2.465-2.544-2.465S3.333 5.02 3.333 6.382c0 1.36 1.14 2.464 2.544 2.464ZM16.666 6.382H8.42M14.122 16.111c1.405 0 2.544-1.103 2.544-2.465 0-1.36-1.139-2.464-2.544-2.464s-2.544 1.103-2.544 2.464c0 1.362 1.14 2.465 2.544 2.465ZM3.333 13.646h8.245"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <!-- eslint-enable -->
          </span>
          <span>{{ t('search.filters.title') }}</span>
          <span
            v-if="appliedFilterAmount > 0"
            class="text-2xs text-static-white bg-background-negative-primary absolute right-0 top-0 flex h-[18px] w-[18px] -translate-y-1/3 translate-x-1/3 items-center justify-center rounded-full"
          >
            {{ appliedFilterAmount }}
          </span>
        </FreeButton>
      </FilterTooltip>
      <slot name="offer-sort-button" />
      <FreeButton
        v-for="(miniFilter, idx) in miniFilters"
        :key="idx"
        class="mini-filter-button"
        :class="{
          active: isFilterApplied(miniFilter.stage),
        }"
        type="button"
        @click="emit('onOpenFilters', miniFilter.stage)"
      >
        <span>{{ miniFilter.title }}</span>
        <span>
          <!-- eslint-disable -->
          <svg
            width="20"
            height="20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.33 6.625a.821.821 0 0 0-.548-.366.764.764 0 0 0-.617.178l-6.16 5.249-6.16-5.249a.764.764 0 0 0-.617-.178.82.82 0 0 0-.549.366.989.989 0 0 0-.146.333 1.052 1.052 0 0 0 .09.723.907.907 0 0 0 .223.275l6.51 5.548c.186.16.414.246.649.246a.998.998 0 0 0 .65-.246l6.509-5.548a.907.907 0 0 0 .223-.275 1.05 1.05 0 0 0 .09-.722.988.988 0 0 0-.147-.334Z"
              fill="currentColor"
            />
          </svg>
          <!-- eslint-enable -->
        </span>
      </FreeButton>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { FreeButton } from 'freedom-shared';

  import { filtersConfig, type FilterStage } from '../config';
  import FilterTooltip from './FilterTooltip.vue';

  const props = defineProps<{
    isFilterApplied: (stage: FilterStage) => boolean;
    appliedFilterAmount: number;
    isFilteredOffersEmpty: boolean;
  }>();

  const emit = defineEmits<{
    onOpenFilters: [stage?: FilterStage];
  }>();

  const route = useRoute();

  const showTooltip = ref<boolean>(!!route.query.iata);

  const { t } = useI18n();

  const miniFilters = [
    {
      title: t('search.filters.airlines'),
      stage: filtersConfig.FILTER_STAGES.AIRLINES,
      dataQaId: 'search.refine.airlines',
    },
    {
      title: t('search.filters.time'),
      stage: filtersConfig.FILTER_STAGES.TIME,
      dataQaId: 'search.refine.time',
    },
    {
      title: t('search.filters.transfers'),
      stage: filtersConfig.FILTER_STAGES.TRANSFERS,
      dataQaId: 'search.refine.transfers',
    },
  ];

  const isCalendarFilterApplied = computed(
    () =>
      showTooltip.value &&
      !props.isFilteredOffersEmpty &&
      Boolean(props.appliedFilterAmount),
  );
</script>

<style scoped lang="postcss">
  .mini-filter-button {
    @apply text-text-neutral-secondary bg-background-neutral-secondary border-situational-lightgrey relative space-x-2 whitespace-nowrap rounded-xl border px-3 py-2 text-sm font-medium leading-5 transition-colors duration-150;

    &.active {
      @apply text-text-positive-primary border-background-positive-primary;
    }
  }
</style>
